<template>
  <div>
    <page-header
      :title="userInfo.full_name"
      :avatar="userInfo.avatar_preview"
    />
    <div class="c-box">
      <form-wrapper
        ref="form"
        :service="Student"
        :formComponent="InnerForm"
        :form.sync="form"
        :errors.sync="errors"
        :objParams="$store.state.userInfo.id"
      />
      <a-divider />
      <a-row :gutter="16">
        <a-col :span="13">
          <password-change-form />
        </a-col>
      </a-row>
    </div>
  </div>
</template>
<script>
import { Student } from '@/api'
import InnerForm from '@/components/forms/StudentForm'
import PasswordChangeForm from '@/components/forms/PasswordChangeForm/'

export default {
  data() {
    return {
      form: {},
      errors: {},
      InnerForm,
      Student,
      header: {
        title: this.$store.state.userInfo.full_name
      }
    }
  },
  components: {
    PasswordChangeForm
  }
}
</script>
